const GUIDELINE_SUBJECTS = {
    CAPTION: 'CAPTION',
    CONTENT: 'CONTENT'
}

export function parseCampaignGuidelineNodes(guidelineNodes) {
    if (!guidelineNodes || !guidelineNodes.edges?.length) {
        return [];
    }

    return guidelineNodes.edges.map(guidelineItem => guidelineItem.node).filter(Boolean);
}

export function getContentGuidelines(guidelines) {
    if (!guidelines || !guidelines.length) {
        return [];
    }

    return guidelines.filter(guideline => guideline.subject === GUIDELINE_SUBJECTS.CONTENT);
}

export function getCaptionGuidelines(guidelines) {
    if (!guidelines || !guidelines.length) {
        return [];
    }

    return guidelines.filter(guideline => guideline.subject === GUIDELINE_SUBJECTS.CAPTION);
}

export function getMustAndMustNotGuidelines(guidelines) {
    if (!guidelines || !guidelines.length) {
        return {must: [], mustNot: []};
    }

    const must = [];
    const mustNot = [];

    guidelines.forEach(guideline => {
        if (guideline.must) {
            must.push(guideline);
        } else {
            mustNot.push(guideline);
        }
    })


    return {must, mustNot};
}



// WEBPACK FOOTER //
// ./components/campaign_content_guidelines/guidelines_utils.js